// Tiny stale-while-revalidate cache: tabs you've already opened render instantly
// from the last payload while fresh data loads in the background. Cleared on logout.
const store = new Map();

export const getCache = (key) => store.get(key);
export const hasCache = (key) => store.has(key);
export const setCache = (key, value) => { store.set(key, value); };
export const clearCache = () => { store.clear(); };
